// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_modal-actions_12hyz_xhta6_181:not(#\\9 ){justify-content:flex-end}.awsui_last-updated-caption_12hyz_xhta6_189:not(#\\9 ){font-size:var(--font-size-body-s-4dzx5q, 12px);line-height:var(--line-height-body-s-egzl4q, 16px);letter-spacing:var(--letter-spacing-body-s-8b9hcs, normal);text-align:end;color:var(--color-text-status-inactive-fg16yu, #687078)}", ""]);
// Exports
module.exports = exports;
